import { Component } from '@angular/core';

@Component({
    selector: 'appc-google-disclosure',
    templateUrl: './google-disclosure.component.html',
    styleUrls: ['./google-disclosure.component.scss'],
    standalone: false,
})
export class GoogleDisclosureComponent {
}
